export type PostStorageLocationDeleteApiApiResponse = /** status 204 Standard response */ void;
export type PostStorageLocationDeleteApiApiArg = {
  body: {
    storageLocationIds: string[];
  };
};
export type PostStorageLocationNoteApiApiResponse = /** status 204 Standard response */ void;
export type PostStorageLocationNoteApiApiArg = {
  body: {
    storageLocationIds: string[];
    note?: string | null;
  };
};
export type GetStorageLocationApiApiResponse =
  /** status 200 Standard response */
  | ({
      storageLocationId: string;
      location: string;
      note?: string | null;
      isEmptyLocation: boolean;
    } | null)[]
  | /** status 204 Standard response */ void;
export type GetStorageLocationApiApiArg = {
  contextTarget: 'TIRE-WAREHOUSE';
  contextId: string;
};
export type PostStorageLocationAddLocationApiApiResponse =
  | /** status 200 Standard response */ ({
      storageLocationId: string;
    } | null)
  | /** status 204 Standard response */ void;
export type PostStorageLocationAddLocationApiApiArg = {
  contextTarget: 'TIRE-WAREHOUSE';
  contextId: string;
  body: {
    storageLocation: ({
      isSelected: boolean;
      /** Aisle, A vector is a parameter defining the warehouse structure. Their combinations create storage locations. */
      vectorType: 'AISLE' | 'RACK' | 'LEVEL' | 'POSITION' | 'OTHER';
      /** Order position of vector type */
      vectorPosition: number;
      /** From which number or letter the labeling of storage locations will start for each vector. */
      symbol?: string | null;
    } | null)[];
    note?: string | null;
  } | null;
};
export type PostStorageLocationGenerateLocationApiApiResponse =
  | /** status 200 Standard response */ ({
      storageLocationIds?: (string | null)[];
      numberGenerated: number;
    } | null)
  | /** status 204 Standard response */ void;
export type PostStorageLocationGenerateLocationApiApiArg = {
  contextTarget: 'TIRE-WAREHOUSE';
  contextId: string;
  body: ({
    isSelected: boolean;
    /** Aisle, A vector is a parameter defining the warehouse structure. Their combinations create storage locations. */
    vectorType: 'AISLE' | 'RACK' | 'LEVEL' | 'POSITION' | 'OTHER';
    /** Order position of vector type */
    vectorPosition: number;
    /** The number from which the combination of storage locations will be calculated */
    number?: number | null;
    /** Numbers or letters that will be used to label the storage locations. */
    symbolType: 'ALPHABET' | 'NUMBERS';
    /** From which number or letter the labeling of storage locations will start. */
    beginAt?: string | null;
  } | null)[];
};
export type GetStorageLocationGeneratorSettingApiApiResponse =
  /** status 200 Standard response */
  | ({
      isSelected: boolean;
      vectorType: 'AISLE' | 'RACK' | 'LEVEL' | 'POSITION' | 'OTHER';
      vectorPosition: number;
      number?: number | null;
      symbolType: 'ALPHABET' | 'NUMBERS';
      beginAt?: string | null;
    } | null)[]
  | /** status 204 Standard response */ void;
export type GetStorageLocationGeneratorSettingApiApiArg = {
  contextTarget: 'TIRE-WAREHOUSE';
  contextId: string;
};
export type GetStorageLocationStatisticsApiApiResponse =
  | /** status 200 Standard response */ ({
      total: number;
      available: number;
      occupied: number;
    } | null)
  | /** status 204 Standard response */ void;
export type GetStorageLocationStatisticsApiApiArg = {
  contextTarget: 'TIRE-WAREHOUSE';
  contextId: string;
};
export type GetStorageLocationByIdApiApiResponse =
  | /** status 200 Standard response */ ({
      storageLocationId: string;
      location: string;
      definition?: {
        vectors: ({
          isSelected: boolean;
          vectorType: 'AISLE' | 'RACK' | 'LEVEL' | 'POSITION' | 'OTHER';
          vectorPosition: number;
          symbolType?: ('ALPHABET' | 'NUMBERS') | null;
          symbol?: string | null;
        } | null)[];
        separator?: string | null;
      } | null;
      isSingleLocation: boolean;
      allowMultipleUsage: boolean;
      note?: string | null;
    } | null)
  | /** status 204 Standard response */ void;
export type GetStorageLocationByIdApiApiArg = {
  storageLocationId: string;
};
export type PatchStorageLocationApiApiResponse = /** status 204 Standard response */ void;
export type PatchStorageLocationApiApiArg = {
  storageLocationId: string;
  body: {
    definition?: {
      vectors: ({
        isSelected: boolean;
        vectorType: 'AISLE' | 'RACK' | 'LEVEL' | 'POSITION' | 'OTHER';
        vectorPosition: number;
        symbolType?: ('ALPHABET' | 'NUMBERS') | null;
        symbol?: string | null;
      } | null)[];
      separator: string;
    } | null;
    note?: string | null;
  } | null;
};
export type PostStorageLocationOccupiedApiApiResponse = /** status 204 Standard response */ void;
export type PostStorageLocationOccupiedApiApiArg = {
  storageLocationId: string;
  body: {
    contextTarget: 'TIRE-SET';
    contextIds: string[];
  } | null;
};
export type PostStorageLocationReleasedApiApiResponse = /** status 204 Standard response */ void;
export type PostStorageLocationReleasedApiApiArg = {
  storageLocationId: string;
  body: {
    contextTarget: 'TIRE-SET';
    contextIds: string[];
  } | null;
};
export type PostStorageLocationAddLocationV2ApiResponse =
  | /** status 200 Standard response */ ({
      storageLocationId: string;
    } | null)
  | /** status 204 Standard response */ void;
export type PostStorageLocationAddLocationV2ApiArg = {
  contextTarget: 'TIRE-WAREHOUSE' | 'WAREHOUSE-SPACE';
  contextId: string;
  body: {
    location: string;
    allowMultipleUsage: boolean;
    note?: string | null;
  } | null;
};
export type PostStorageLocationGenerateLocationV2ApiResponse =
  | /** status 200 Standard response */ ({
      storageLocationIds?: (string | null)[];
      numberGenerated: number;
    } | null)
  | /** status 204 Standard response */ void;
export type PostStorageLocationGenerateLocationV2ApiArg = {
  contextTarget: 'TIRE-WAREHOUSE';
  contextId: string;
  body: ({
    definition?: {
      isSelected: boolean;
      /** Aisle, A vector is a parameter defining the warehouse structure. Their combinations create storage locations. */
      vectorType: ('AISLE' | 'RACK' | 'LEVEL' | 'POSITION' | 'OTHER') | null;
      /** Order position of vector type */
      vectorPosition: number | null;
      /** The number from which the combination of storage locations will be calculated */
      number?: number | null;
      /** Numbers or letters that will be used to label the storage locations. */
      symbolType: 'ALPHABET' | 'NUMBERS';
      /** From which number or letter the labeling of storage locations will start. */
      beginAt?: string | null;
    } | null;
    allowMultipleUsage: boolean;
  } | null)[];
};
export type PatchStorageLocationV2ApiResponse = /** status 204 Standard response */ void;
export type PatchStorageLocationV2ApiArg = {
  storageLocationId: string;
  body: {
    definition?: {
      vectors: ({
        isSelected: boolean;
        vectorType: ('AISLE' | 'RACK' | 'LEVEL' | 'POSITION' | 'OTHER') | null;
        vectorPosition: number | null;
        symbolType?: ('ALPHABET' | 'NUMBERS') | null;
        symbol?: string | null;
      } | null)[];
      separator: string;
    } | null;
    allowMultipleUsage: boolean;
    note?: string | null;
  } | null;
};
export type PostStorageLocationSetAsInactiveApiApiResponse =
  /** status 204 Standard response */ void;
export type PostStorageLocationSetAsInactiveApiApiArg = {
  body: {
    storageLocationIds: string[];
  };
};
export type PostStorageLocationSetAsActiveApiApiResponse = /** status 204 Standard response */ void;
export type PostStorageLocationSetAsActiveApiApiArg = {
  body: {
    storageLocationIds: string[];
  };
};
